function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic_no_address");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "PERFIL",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Perfil_no_address",
  transform: "translate(-329.000000, -496.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Direcciones",
  transform: "translate(127.000000, 395.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_no_address",
  transform: "translate(203.000000, 104.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path-3",
  stroke: "#D8D8D8",
  strokeWidth: 5,
  strokeLinecap: "round",
  points: "96 7.10542736e-15 132.189186 7.10542736e-15 143.856013 11.6668264 132.189186 23.3336528 96 23.3336528"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,113 L176,113",
  id: "Path-3-Copy-3",
  stroke: "#979797",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-3-Copy",
  stroke: "#D8D8D8",
  strokeWidth: 5,
  strokeLinecap: "round",
  transform: "translate(78.928006, 41.666826) scale(-1, 1) translate(-78.928006, -41.666826) ",
  points: "63 34 87.0898294 34 94.8560127 41.6668264 87.0898294 49.3336528 63 49.3336528"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-3-Copy-2",
  stroke: "#D8D8D8",
  strokeWidth: 5,
  strokeLinecap: "round",
  points: "96 56 120.089829 56 127.856013 63.6668264 120.089829 71.3336528 96 71.3336528"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96,126 L96,0.5",
  id: "Line",
  stroke: "#D8D8D8",
  strokeWidth: 5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96,142 L96,110",
  id: "Line-Copy",
  stroke: "#D8D8D8",
  strokeWidth: 5,
  strokeLinecap: "round",
  transform: "translate(96.000000, 126.000000) rotate(-270.000000) translate(-96.000000, -126.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.121385,113 L156.121385,94.4378326",
  id: "Path-5",
  stroke: "#979797",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.194888,104.01191 C149.62957,103.328233 146.34691,100.136874 146.34691,94.4378326 C146.34691,88.7387911 149.62957,79.0037878 156.194888,65.2328227 C162.748697,80.4733528 166.025601,90.2083561 166.025601,94.4378326 C166.045708,100.007477 162.768803,103.198836 156.194888,104.01191 Z",
  id: "Path-6",
  stroke: "#979797",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-7",
  stroke: "#979797",
  strokeWidth: 2,
  strokeLinejoin: "round",
  points: "74.2442431 113 59.5692509 98.3250078 44.8942588 113"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#979797",
  strokeWidth: 2,
  cx: 56.5,
  cy: 78.5,
  r: 8.5
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-8",
  stroke: "#979797",
  strokeWidth: 2,
  strokeLinejoin: "round",
  points: "52.5163372 105.195095 33.896367 86.5751247 7.54680483 112.924687"
})))));

var SvgIcNoAddress = function SvgIcNoAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "178px",
    height: "132px",
    viewBox: "0 0 178 132",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNoAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_no_address.bf2b2698.svg";
export { ForwardRef as ReactComponent };